document.addEventListener('DOMContentLoaded', () => {
    const openModal = document.getElementById("container-size-guide");
const closeBtn = document.getElementById("close-closeBtn");
const modal = document.getElementById('container-modal');
const containerContent = document.getElementById('container-modal-content');

openModal.addEventListener('click', () => {
    modal.style.display = 'block';
});

closeBtn.addEventListener('click', () => {
    modal.style.display = 'none';
});

containerContent.addEventListener('click', (event) => {
    if (event.target === containerContent) {
        modal.style.display = 'none';
    }
});

window.addEventListener('click', (event) => {
    if (event.target === modal) {
        modal.style.display = 'none';
    }
});

const radios = document.querySelectorAll('input[name="unit"]');
const measures = document.querySelectorAll('.measure');

    radios.forEach(radio => {
    radio.addEventListener('change', function() {
    const unit = this.value;
        measures.forEach(measure => {
            const cmValue = measure.getAttribute('data-cm');
            let displayValue;
            if (unit === 'cm') {
                displayValue = `${cmValue}`;
            } else if (unit === 'inch') {
                const inValue = Math.trunc(cmValue / 2.54);
                displayValue = `${inValue}`;
            }
            measure.textContent = displayValue;
        });
    });
    });

});
